import {GameStateEnums} from '../../../../../shared/GameEnums'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGameManager} from '../UIGameManager'
import {UIGameMapCornerView} from './UIGameMapCornerView'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import {Sound} from '../../Sound'
import {MechanicRobberState, TileCornerBuildingType} from '@colonist/game-states'
import {TileCorner, TileHex, Point} from '@colonist/game-mechanic-validators'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import SoundType = Sound.SoundType
import {ArrayUtils} from '@colonist/utils'

export class UIGameMapMetropolisController implements UIGameMechanic {
    private readonly uiGameManager: UIGameManager
    private readonly robberState?: MechanicRobberState | undefined
    private readonly metropolisViews: UIGameMapCornerView[] = []

    constructor(uiGameManager: UIGameManager, robberState: MechanicRobberState | undefined) {
        this.uiGameManager = uiGameManager
        this.robberState = robberState
        this.uiGameManager.eventController.registerUIGameMechanic(this)

        this.metropolisViews = []
        this.drawMetropolises(true)
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.MapStateUpdated: this.drawMetropolises(data as boolean == false); break
            case UIGameEventEnums.RobberMoved: this.setMetropolisLayer(); break
            default: break
        }
    }

    private drawMetropolises(drawExistingMetropolises: boolean) {
        this.removeStolenMetropolises()
        for(const corner of this.uiGameManager.gameState.mapState.tileState.tileCorners) {
            if(corner.buildingType != TileCornerBuildingType.City) continue
            if(!corner.doesCornerHaveMetropolis()) continue
            if(this.cornerExists(corner)) continue
            this.drawMetropolisOnCorner(corner, drawExistingMetropolises)
        }
    }

    private removeStolenMetropolises() {
        const metropolisViews = [...this.metropolisViews]
        for(const metropolisView of metropolisViews) {
            if(metropolisView.corner.doesCornerHaveMetropolis()) continue

            metropolisView.parent.removeChild(metropolisView)
            ArrayUtils.removeElementFromArray(this.metropolisViews, metropolisView)
        }
    }

    private cornerExists(corner: TileCorner): boolean {
        for(const metropolisView of this.metropolisViews) {
            if(metropolisView.corner.sameCorner(corner)) return true
        }
        return false
    }

    private drawMetropolisOnCorner(corner: TileCorner, drawExistingMetropolis: boolean) {
        const metropolisBonus = corner.getMetropolis()
        if(metropolisBonus == undefined) return
        const texture = UIGameSpriteHandler.getMetropolisForCornerBonusType(metropolisBonus)

        const mapView = this.uiGameManager.mapController.mapView
        const center = corner.hexCorner.toPixel(mapView.mapCenter, mapView.hexagonHeight / 2)
        const x = center.x - mapView.cornerCircleR * 0.47
        const y = center.y - mapView.cornerCircleR * 1.285
        const animationStartY = drawExistingMetropolis ? y : y - mapView.hexagonHeight

        const w = this.uiGameManager.mapController.mapView.cornerCircleR * 2
        const h = w

        const layer = mapView.layers.metropolis
        const metropolisView = new UIGameMapCornerView(corner, x, animationStartY, w, h, layer, texture, mapView)

        const hexCorner = new Point(metropolisView.x, y)
        metropolisView.animationController.animationCompleteCallBack = () => {
            if(drawExistingMetropolis) return
            if(this.uiGameManager.gameController.isReplay) return

            Sound.playSound(SoundType.MetropolisPlace)
        }
        metropolisView.animationController.animateTo(hexCorner)
        this.metropolisViews.push(metropolisView)
        this.uiGameManager.mapController.mapView.sortChildren()
        this.setMetropolisLayer()
    }

    private setMetropolisLayer() {
        if(this.robberState == undefined) return

        const robberTile = this.uiGameManager.gameState.mapState.tileState.tiles[this.robberState.locationTileIndex]
        this.adjustLayeringOnMetropolisIcons(robberTile)
    }

    private adjustLayeringOnMetropolisIcons(newRobberTile: TileHex) {
        const mapView = this.uiGameManager.mapController.mapView
        for(const metropolisView of this.metropolisViews) {
            const metropolisCorner = metropolisView.corner.hexCorner
            for(const touchingCorner of newRobberTile.hexFace.corners()) {
                if(!touchingCorner.sameCorner(metropolisCorner)) continue

                const isTouchingCornerNorthWest = touchingCorner.x == newRobberTile.hexFace.x && touchingCorner.y == newRobberTile.hexFace.y - 1
                const halfALayer = 0.5
                const newMetropolisLayer = isTouchingCornerNorthWest ? mapView.layers.robber - halfALayer : mapView.layers.metropolis

                metropolisView.zIndex = newMetropolisLayer
            }
        }
        mapView.sortChildren()
    }
}
